<template>
    <div>
        <v-data-table
            id="school-table"
            :items="schools"
            :headers="table.headers"
            sort-by="percentage"
            sort-desc
            :items-per-page="15"
        >
            <template v-slot:item.name="{ item }">
                <div class="name">
                    {{ item.name }}
                </div>
            </template>
            <template v-slot:item.state="{ item }">
                <div class="school">
                    <v-chip
                        class="ma-2"
                        :color="getStateColor(item.state)"
                        text-color="white"
                    >
                        {{ item.state }}
                    </v-chip>
                </div>
            </template>
            <template v-slot:item.level="{ item }">
                <div class="school">
                    <v-chip class="ma-2">
                        {{ formatTier(item.level) }}
                    </v-chip>
                </div>
            </template>
            <template v-slot:item.percentage="{ item }">
                <v-chip
                    class="ma-2"
                    :color="getAcceptanceColor(item.percentage)"
                    text-color="white"
                    v-if="item.percentage"
                >
                    {{ item.percentage }}%
                </v-chip>
            </template>
            <template v-slot:item.id="{ item }">
                <v-btn
                    color="primary"
                    @click="open(item.id)"
                    icon
                    class="action-btn"
                >
                    <v-icon>mdi-help-circle</v-icon>
                </v-btn>
                <v-btn
                    class="action-btn"
                    color="secondary"
                    @click="add(item)"
                    icon
                    v-if="!isSchoolSelected(item)"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn
                    v-else
                    @click="remove(item)"
                    color="error"
                    icon
                    class="action-btn"
                >
                    <v-icon>mdi-minus</v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <v-dialog v-model="showDialog" max-width="900">
            <School :id="singleSchoolID"></School>
        </v-dialog>
    </div>
</template>

<script>
import schoolService from '../services/SchoolService';
import School from '../views/School';
import { checkSchoolNameInArray } from '../store';
import axios from 'axios';

export default {
    name: 'SchoolList',
    components: {
        School,
    },
    created() {
        axios
            .get(
                `${process.env.VUE_APP_API_BASE}schools?state=${this.$store.getters.user.state}`
            )
            .then(response => {
                this.schools = response.data;
            });
    },
    data() {
        return {
            table: {
                headers: [
                    {
                        text: 'Name',
                        value: 'name',
                        sortable: true,
                    },
                    {
                        text: 'State',
                        value: 'state',
                        sortable: true,
                        align: 'left',
                    },
                    {
                        text: 'Tier',
                        value: 'level',
                        sortable: true,
                        align: 'left',
                    },
                    {
                        text: 'Out of State Percentage',
                        value: 'percentage',
                        sortable: true,
                        align: 'center',
                    },
                    {
                        text: 'Public/Private',
                        value: 'type',
                        sortable: true,
                        align: 'center',
                    },
                    {
                        text: 'Actions',
                        value: 'id',
                        sortable: false,
                    },
                ],
            },
            singleSchoolID: null,
            showDialog: false,
            schoolIDs: [],
            schools: [],
        };
    },
    methods: {
        getAcceptanceColor(percentage) {
            return schoolService.getAcceptanceColor(percentage);
        },
        getStateColor(schoolState) {
            return schoolService.getStateColor(
                schoolState,
                this.$store.getters.user.state
            );
        },
        open(id) {
            this.singleSchoolID = id;
            this.showDialog = true;
        },

        add(item) {
            this.$store.commit('addSelectedSchool', item);
        },

        remove(item) {
            this.$store.commit('rmSelectedSchool', item.id);
        },

        isSchoolSelected(school) {
            return checkSchoolNameInArray(
                this.$store.getters.selectedSchools,
                school
            );
        },

        formatTier(value) {
            if (value !== undefined) {
                return value.replace('Tier', '');
            }
        },
    },
};
</script>
<style lang="scss">
#school-table {
    tbody {
        tr {
            td {
                padding-left: 0;
                padding-right: 0;
            }

            & > td:first-child,
            & > td:last-child {
                margin-top: 1em;
                margin-bottom: 1em;

                .v-data-table__mobile-row__header {
                    display: none;
                }

                .v-data-table__mobile-row__cell {
                    width: 100%;
                    text-align: left;
                    font-size: 1.2em;
                }
            }

            & > td:last-child {
                .v-data-table__mobile-row__cell {
                    text-align: center;
                }
            }
        }
    }

    .view-more {
        display: none;
    }

    @media (max-width: 768px) {
        .view-more {
            display: block;
        }
    }
}
</style>
